class StopModel extends App.Models.BaseModel {
  modelUrl = "Stop";

  fetchWithCriteria = obj => {
    return Monet.Model.fetchWithCriteria({
      options: obj,
      model: this
    });
  };

  orders = obj => {
    return Monet.Model.hasMany({
      options: obj,
      parent: this,
      collection: App.Collections.Orders,
      model: App.Models.Order
    });
  };

  getStopArrived = () => {
    const route = this.attributes.route;
    if (route) {
      const stops = route.stops;
      if (stops) {
        var dataLength = stops.length;

        for (var i = 0; i < dataLength; i++) {
          const stop = stops[i];
          const actualArrive = stop.actualArrival;
          const actualDeparture = stop.actualDeparture;
          const cancelCode = stop.cancelCode;

          if (actualArrive && !actualDeparture && !cancelCode) {
            return stop;
          }
        }
      }
    }
  };
}

App.Models.Stop = StopModel;
